var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "20px",
    height: "30px",
    viewBox: "0 0 34.65 34.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    className: "fil0",
    d: "M25.27 17.33c-2.79,0 -5.05,2.26 -5.05,5.05 0,2.79 2.26,5.05 5.05,5.05l9.39 0 0 7.22 -34.65 0 0 -24.55 34.65 0 0 7.22 -9.39 0zm1.44 7.22l-1.44 0c-1.2,0 -2.17,-0.97 -2.17,-2.17 0,-1.2 0.97,-2.17 2.17,-2.17l1.44 0c1.2,0 2.17,0.97 2.17,2.17 0,1.2 -0.97,2.17 -2.17,2.17l0 0zm-3.61 -24.55l4.99 8.41 -25.78 0.12 20.8 -8.52 0 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.dec4409dbbf74e10842d90f5872af14c.svg";
export { ForwardRef as ReactComponent };